import React from 'react';
import { Box, ButtonV2, Flex, FlexProps, TextV2 } from '@withjoy/joykit';
import { useHistory } from '@react-router';
import { ProgressRing } from '../ProgressRing';
import qs from 'query-string';
import { Page, useRegistryGiftCountsTelemetry } from '../../telemetry';
import { pxToRem } from '@withjoy/joykit/theme';
import { useCatalogContext } from '../../../Catalog';
import { useRoutePaths } from '@apps/registry/admin/Registry.routes';
import { useTranslation } from '@shared/core';

interface PriceRangeProps extends FlexProps {
  title: string;
  targetGiftCount: number;
  completedGiftCount: number;
  isOpen: boolean;
  priceRangeQuery: string;
  page: Page;
  closeDrawer?: () => void;
}

export const PriceRangeV2 = ({ title, targetGiftCount, completedGiftCount, isOpen, priceRangeQuery, closeDrawer, page, ...props }: PriceRangeProps) => {
  const history = useHistory();
  const paths = useRoutePaths();
  const { priceRangeClick } = useRegistryGiftCountsTelemetry();
  const { removeSelectedCategory } = useCatalogContext();
  const { t } = useTranslation('sharedComponents');
  const { shopNow } = t('registryGiftAdvisorV2');

  const handleOnClickShopPriceRange = () => {
    priceRangeClick(title, page, 'Gift Count / Price Point Guide');
    const priceCustom = {
      pf: `priceRange=${priceRangeQuery}`,
      showFilters: true
    };
    removeSelectedCategory();
    history.push({ pathname: `${paths.catalog.path}/recommended`, search: qs.stringify(priceCustom) });

    closeDrawer?.();
  };

  return (
    <Box {...props} width="100%" flexDirection="row" display="flex">
      <ProgressRing
        isOpen={isOpen}
        currentGiftCount={completedGiftCount}
        progressPercent={(completedGiftCount / targetGiftCount) * 100}
        progressColor="#595959"
        countTextColor="#595959"
        typographyVariant="hed1"
      />
      <Flex flexDirection="column" marginLeft={3}>
        <TextV2 fontSize={pxToRem(15)} color="mono10" display="flex" alignItems="center">
          {title}
        </TextV2>
        <ButtonV2
          onClick={handleOnClickShopPriceRange}
          marginTop={pxToRem(2)}
          variant="ghost"
          padding={0}
          height="fit-content"
          width="fit-content"
          color="mono10"
          typographyVariant="label2"
        >
          {shopNow()}
        </ButtonV2>
      </Flex>
    </Box>
  );
};
